import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import { user } from './user'
import { application } from './application'
import { payment } from './payment'
import { i18n } from './i18n'

import createPersistedState from 'vuex-persistedstate'
import SecureLS from 'secure-ls'
const ls = new SecureLS({ isCompression: false })
Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [
        createPersistedState({
            key: 'adminState',
            paths: ['user', 'application', 'payment', 'i18n.currentLocale']
        })
    ],
    modules: {
        user,
        application,
        payment,
        i18n
    },
    state: {
        $i18n: null
    },
    mutations: {
        SET_I18N(state, i18nInstance) {
            state.$i18n = i18nInstance
        }
    },
    strict: process.env.DEV,
})

